export default [
  { to: 'behandlingsrutiner', title: 'Behandlingsrutiner' },
  { to: 'kontaktvagar', title: 'Kontaktvägar' },
  { to: 'information', title: 'Information' },
  { to: 'patient', title: 'Patient och närstående' },
];
